<template>
  <div :class="$style.base">
    <MarketingArea />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import MarketingArea from './marketing-area/index.vue';

export default defineComponent({
  components: {
    MarketingArea,
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  width: 100%;
}
</style>
